function ClientPersonNote() {
  return <div />;
}

export default ClientPersonNote;
